module.exports = __webpack_public_path__ + "media/mem_sale_m.32ccdc40.mp4";